module.exports = __webpack_public_path__ + "static/laurent-44-2687700c515e84527ad49972311d29d5.jpg";